/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiProductsqueryBannersGet } from '../fn/banners/api-productsquery-banners-get';
import { ApiProductsqueryBannersGet$Params } from '../fn/banners/api-productsquery-banners-get';
import { apiProductsqueryBannersGet$Plain } from '../fn/banners/api-productsquery-banners-get-plain';
import { ApiProductsqueryBannersGet$Plain$Params } from '../fn/banners/api-productsquery-banners-get-plain';
import { BannerDto } from '../models/banner-dto';

@Injectable({ providedIn: 'root' })
export class BannersService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiProductsqueryBannersGet()` */
  static readonly ApiProductsqueryBannersGetPath = '/api/productsquery/banners';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductsqueryBannersGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsqueryBannersGet$Plain$Response(params?: ApiProductsqueryBannersGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BannerDto>>> {
    return apiProductsqueryBannersGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProductsqueryBannersGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsqueryBannersGet$Plain(params?: ApiProductsqueryBannersGet$Plain$Params, context?: HttpContext): Observable<Array<BannerDto>> {
    return this.apiProductsqueryBannersGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BannerDto>>): Array<BannerDto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductsqueryBannersGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsqueryBannersGet$Response(params?: ApiProductsqueryBannersGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BannerDto>>> {
    return apiProductsqueryBannersGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProductsqueryBannersGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsqueryBannersGet(params?: ApiProductsqueryBannersGet$Params, context?: HttpContext): Observable<Array<BannerDto>> {
    return this.apiProductsqueryBannersGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BannerDto>>): Array<BannerDto> => r.body)
    );
  }

}
